import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import SelectDefault from 'react-select';
import Async from 'react-select/async';
import * as style from './Select.styl';
const WINDOW_COUNT = 100;
export class Select extends React.Component {
    constructor(props) {
        super(props);
    }
    searchChildOptions(options, input) {
        const getLabelDelegate = this.props.getOptionLabel || ((option) => option.label);
        const filteredChildOptions = [];
        for (const option of options) {
            const optionLabel = getLabelDelegate(option);
            if (filteredChildOptions.length < WINDOW_COUNT && optionLabel.toLowerCase().indexOf(input.toLowerCase()) >= 0) {
                filteredChildOptions.push(option);
            }
        }
        return filteredChildOptions;
    }
    // Note that this is only used if more than 100 options are passed in.
    asyncLoad(input) {
        var _a;
        const options = this.props.options;
        const value = this.props.value;
        const filteredOptions = [];
        const getValueDelegate = this.props.getOptionValue || ((option) => option);
        const getLabelDelegate = this.props.getOptionLabel || ((option) => option.label);
        for (const option of options) {
            const optionValue = getValueDelegate(option);
            const optionLabel = getLabelDelegate(option);
            if (value && optionValue === value) {
                // if the value of an option matches the currently selected value, add it to the current 'window' subset
                filteredOptions.push(option);
            }
            else if (((_a = option.options) === null || _a === void 0 ? void 0 : _a.length) && optionLabel.toLowerCase().indexOf(input.toLowerCase()) < 0) {
                // if the input doesn't match the option but the option has child options we need to search these child options
                // if the input matches child options we need to add the parent and all matched child options
                const matchedChildOptions = this.searchChildOptions(option.options, input);
                if (filteredOptions.length < WINDOW_COUNT && matchedChildOptions.length) {
                    filteredOptions.push(Object.assign(Object.assign({}, option), { options: matchedChildOptions }));
                }
            }
            else if (filteredOptions.length < WINDOW_COUNT && optionLabel.toLowerCase().indexOf(input.toLowerCase()) >= 0) {
                // if the input matches an option label and there are under a hundred in the current 'window' subset, add the option
                filteredOptions.push(option);
            }
        }
        return Promise.resolve(filteredOptions);
    }
    render() {
        let { options } = this.props;
        if (!options) {
            options = [];
        }
        if (options.length <= WINDOW_COUNT) {
            return _jsx(SelectDefault, Object.assign({}, this.props, { openOnFocus: true, styles: this.props.styles }));
        }
        const asyncProps = Object.assign({}, this.props);
        // we don't pass options directly to the AsyncSelect,
        // since they are loaded on `asyncLoad`
        delete asyncProps.options;
        return (_jsx(Async, Object.assign({}, asyncProps, { className: `${style.global} ${asyncProps.className ? asyncProps.className : ''}`, cacheOptions: false, defaultOptions: true, loadOptions: (input) => this.asyncLoad(input), openOnFocus: true, styles: asyncProps.styles })));
    }
}
